import { useEffect, useMemo, useState } from 'react';

const EMPTY_ASSIGNED_IDS = new Set<number>();

/**
 * Ids assigned while the add dialog is open, starting from the ones already
 * assigned each time it opens; `changed` once the draft differs from them.
 */
export function useAssignedFieldsDraft(
  open: boolean,
  initialAssignedOrder: readonly number[]
) {
  const [draft, setDraft] = useState<ReadonlySet<number>>(EMPTY_ASSIGNED_IDS);

  const initialAssignedIds = useMemo(
    () => new Set(initialAssignedOrder),
    [initialAssignedOrder]
  );

  useEffect(() => {
    if (open) {
      setDraft(initialAssignedIds);
    }
  }, [open, initialAssignedIds]);

  const changed =
    draft.size !== initialAssignedIds.size ||
    [...draft].some(id => !initialAssignedIds.has(id));

  return { draft, setDraft, changed, initialAssignedIds };
}
